import * as pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import XLSX from "xlsx-js-style";

// Функция, отвечающая за экспорт таблицы в формате EXCEL
export function excelExport(valueToExport: any, columns: any, tableName: string) {   
        let colNames = columns.map((item: any) => item.pdfHeader)
        colNames = colNames.filter((item: any) => item != null)
        const worksheet = XLSX.utils.json_to_sheet(valueToExport);
        XLSX.utils.sheet_add_aoa(worksheet, [colNames], { origin: "A1" });
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });
        saveAsExcelFile(excelBuffer, tableName);
}

// Подфункция, отвечающая за экспорт таблицы в формате EXCEL
export function saveAsExcelFile(buffer: BlobPart, tableName: string) {
    import('file-saver').then((module) => {
        if (module && module.default) {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            module.default.saveAs(data, tableName + ' (' +  new Date().toLocaleString()?.replace(/:/g,'-') + ')' + EXCEL_EXTENSION);
        }
    });
}

// Функция, отвечающая за экспорт таблицы в формате CSV
export function csvExport(valueToExport: any, columns: any, exportName: any) {
    const headerRow: any[] = [];
    // форматирование данных для экспорта
    columns?.map((item: any) => {
        if (item.pdfHeader && !item.hidden) {
            headerRow.push(item.pdfHeader)
        }
    })
    let parts: string[][] = valueToExport.map((item: any) => (Object.values(item).map((value: any) => value ? value : '-')));
    let bodyArray: string[][] = []
    bodyArray.push(headerRow)
    parts.forEach((item: string[]) => {
        bodyArray.push(item)
    })
    let csv = arrayToCsv(bodyArray)
    downloadBlob("\uFEFF" + csv, `${exportName}.csv`, 'text/csv')
}

function arrayToCsv(data: any) {
    return data.map((row: any) =>
        row
            .map(String)  // convert every value to String
            .map((v: any) => v?.replaceAll('"', '""'))  // escape double quotes
            .map((v: any) => `"${v}"`)  // quote it
            .join(',')  // comma-separated
    ).join('\r\n');  // rows starting on new lines
}

function downloadBlob(content: any, filename: any, contentType: any) {
    // Create a blob
    let blob = new Blob([content], { type: contentType });
    let url = URL.createObjectURL(blob);
    // Create a link to download it
    let pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    pom.click();
}

// функция определения размера страницы для PDF - экспорта в зависимости от количества колонок
export function definePageSize(numOfCols: any) {
    if (numOfCols < 7) {
        return 'A4';
    }
    if (numOfCols < 9) {
        return 'A3';
    }
    if (numOfCols < 13) {
        return 'A2';
    }
    return 'A1';
}


export function pdfExport(valueToExport: any, columns: any, exportName: any) {
    const headerRow: any[] = [];
    let width: (string | number)[] = [];
    // форматирование данных для экспорта
    columns?.map((item: any) => {
        if (item.pdfHeader && !item.hidden) {
            headerRow.push({ text: item.pdfHeader, bold: true, fillColor: '#D2E3EF' })
            width.push(70)
        }
    })
    width = width.map((item: any) => Number.isNaN(item) ? 100 : item)
    let parts: string[][] = valueToExport.map((item: any) => (Object.values(item).map((value: any) => value ? value : '-')));
    let bodyArray: string[][] = []
    bodyArray.push(headerRow)
    parts.forEach((item: string[]) => {
        bodyArray.push(item)
    })
    let docDefinition: any = {
        pageSize: definePageSize(headerRow.length),
        content: [
            {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: width,
                    body: bodyArray
                }
            }
        ],
        defaultStyle: {
            fontSize: 10,
            bold: false,
        }
    };
    pdfMake.createPdf(docDefinition, undefined, undefined, pdfFonts.pdfMake.vfs).download(`${exportName}.pdf`);
}
